import React, { useEffect, useState, useRef } from "react";

import Table from "../../includes/table/table.component";
import Alert from "../../includes/alert/alert.component";
import Modal from "../../includes/modal/modal.component";
import { ReactComponent as Edit } from "../../../assets/icons/EditSquare.svg";
import { connect } from "react-redux";
import {
  fetchEducationalCategories,
  deleteEducationalCategory,
  deleteEducationalCategories,
} from "../../../redux/actions/educationalCategoriesActions";
import { clearErrors } from "../../../redux/actions/errorActions";
import { clearSuccess } from "../../../redux/actions/successActions";
import "./css/style.css";
import AddEducationalForm from "./addEducationalForm.component";
import DeleteDialog from "../../includes/confirm-dialog/confirmDialog.component";
import ActionButton from "../../includes/button/actionButton.component";
import Snackbar from "../../includes/snackbar/snackbar.component";
import DateWrapper from "../../includes/date-wrapper/date-wrapper.component";
import { show } from "../../../assets/js/globalFunctions";

const EducationalCategories = (props) => {
  const headers = [
    { value: "name", text: "Class", align: "left" },
    { value: "createdAt", text: "Date created", wrapper: DateWrapper },
  ];

  const { educationalCategories, error, success, role, roles } = props;
  const [items, setItems] = useState([]);
  const [
    selectedEducationalCategories,
    setSelectedEducationalCategories,
  ] = useState([]);
  const [currentActionClass, setCurrentActionClass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [educationalCategoriesAlert, setEducationalCategoriesAlert] = useState({
    show: false,
    type: "success",
    message: "Selected class(es) deleted successfully",
  });
  const [classForm, setClassForm] = useState({
    show: false,
    type: "edit",
    category: null,
  });
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({ message: "", type: "error" });

  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (error.id) {
        const message =
          typeof error.msg === "object" ? error.msg.join("<br/>") : error.msg;
        let alert_ = { type: "error", show: true, message };
        if (error.id === "DELETE_EDUCATIONAL_CATEGORY_FAILURE") {
          setEducationalCategoriesAlert({ ...alert_ });
          props.clearErrors();
        } else if (error.id === "DELETE_EDUCATIONAL_CATEGORIES_FAILURE") {
          const message =
            typeof error.msg === "object" ? error.msg.join("<br/>") : error.msg;
          setEducationalCategoriesAlert({ ...alert_ });
          props.clearErrors();
        } else if (error.id === "ADD_EDUCATIONAL_CATEGORY_FAILURE") {
          const message =
            typeof error.msg === "object" ? error.msg.join("<br/>") : error.msg;
          setEducationalCategoriesAlert({ ...alert_ });
          props.clearErrors();
        } else if (error.id === "EDIT_EDUCATIONAL_CATEGORY_FAILURE") {
          const message =
            typeof error.msg === "object" ? error.msg.join("<br/>") : error.msg;
          setEducationalCategoriesAlert({ ...alert_ });
          props.clearErrors();
        }
        props.clearErrors();
      } else if (success.id) {
        let alert_ = { type: "success", show: true, message: success.msg };
        if (success.id === "DELETE_EDUCATIONAL_CATEGORY_SUCCESS") {
          setEducationalCategoriesAlert({ ...alert_ });
          props.clearSuccess();
        } else if (success.id === "DELETE_EDUCATIONAL_CATEGORIES_SUCCESS") {
          setEducationalCategoriesAlert({
            ...alert_,
          });
          props.clearSuccess();
        } else if (success.id === "ADD_EDUCATIONAL_CATEGORY_SUCCESS") {
          setEducationalCategoriesAlert({
            ...alert_,
          });
          props.clearSuccess();
        } else if (success.id === "EDIT_EDUCATIONAL_CATEGORY_SUCCESS") {
          setEducationalCategoriesAlert({
            ...alert_,
          });
          props.clearSuccess();
        }
        props.clearSuccess();
      }
    }
  });

  useEffect(() => {
    if (role) {
      props.fetchEducationalCategories();
    }
  }, [role]);
  // useEffect(() => {
  //   if (currentActionClass) setCreationModal(true);
  // }, [currentActionClass]);

  const deleteSelectedEducationalCategories = () => {
    if (selectedEducationalCategories.length < 1) {
      setSnackbar({ message: "No class was selected", type: "error" });
      return;
    } else if (selectedEducationalCategories.length == 1) {
      props.deleteEducationalCategory(selectedEducationalCategories[0]._id);
    } else {
      props.deleteEducationalCategories(
        selectedEducationalCategories.map((category) => category._id)
      );
    }
    // setLoading(true);
    // setTimeout(() => {
    //   let deleted = [];
    //   let arr = items.filter((item) => {
    //     let isSelected = selectedEducationalCategories.includes(item);
    //     if (isSelected) deleted.push(item.name);
    //     return !isSelected;
    //   });
    //   setItems(arr);
    //   setLoading(false);
    //   setSelectedEducationalCategories([]);
    //   setEducationalCategoriesAlert({
    //     ...educationalCategoriesAlert,
    //     show: true,
    //     message:
    //       deleted.length == 1
    //         ? `Class "${deleted[0]}" was successfully deleted`
    //         : deleted.length < 6
    //         ? `EducationalCategories "${deleted.join(", ")}" deleted successfully`
    //         : `All selected educationalCategories were deleted successfully`,
    //   });
    // }, 5000);
  };

  return (
    <div id="educationalCategories" className="page-padding">
      {role && (
        <div>
          <DeleteDialog
            show={deleteDialog}
            onCancel={() => {
              setDeleteDialog(false);
            }}
            onContinue={() => {
              setDeleteDialog(false);
              deleteSelectedEducationalCategories();
            }}
            onClose={() => {
              setDeleteDialog(false);
            }}
            title="Delete Class"
            message={`Are you sure you want to delete the class${
              selectedEducationalCategories.length > 1 ? "es" : ""
            }?`}
          />
          <Snackbar
            snack={snackbar}
            reset={() => {
              setSnackbar({ message: "" });
            }}
          />
          <div className="d-flex justify-content-between">
            <h3 className="title-text">Educational Categories</h3>
            <div>
              <AddEducationalForm
                show={classForm.show}
                onClose={() => {
                  setClassForm({ ...classForm, show: false });
                }}
                onComplete={(val) => {
                  setClassForm({ ...classForm, show: false });
                  // setEducationalCategoriesAlert({
                  //   message: `New class "${val.name}" added successfully`,
                  //   show: true,
                  // });
                  let arr = items.slice();
                  arr.push({
                    ...val,
                    createdAt: "25/02/2020",
                    creator: { name: "Victor" },
                  });
                  setItems(arr);
                }}
                onSetSnackbar={(val) => {
                  setSnackbar(val);
                }}
                category={classForm.category}
                type={classForm.type}
              />

              {show(1, role, roles) && (
                <ActionButton
                  onClick={() => {
                    setClassForm({ type: "Create", show: true });
                  }}
                  className="mr-2 mr-md-4 mb-2"
                />
              )}
              {show(1, role, roles) && (
                <ActionButton
                  delete
                  onClick={() => {
                    setDeleteDialog(true);
                  }}
                  className="mr-2 mr-md-3"
                />
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center">
            {educationalCategoriesAlert.show && (
              <Alert
                type={educationalCategoriesAlert.type}
                message={educationalCategoriesAlert.message}
                style={{ maxWidth: 500, flexGrow: 1 }}
                className="mt-3"
                onClose={() => {
                  setEducationalCategoriesAlert({
                    show: false,
                    message: "",
                  });
                }}
              />
            )}
          </div>
          <Table
            headers={headers}
            items={educationalCategories}
            selectable={show(1, role, roles)}
            action={show(1, role, roles) && <Edit style={{ width: 20 }} />}
            onItemsSelected={(val) => {
              setSelectedEducationalCategories(val);
            }}
            onActionClicked={(item) => {
              setCurrentActionClass(item);
              setClassForm({ type: "Edit", show: true, category: item });
            }}
            loading={loading}
            className="mt-4"
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  educationalCategories: state.educationalCategories.educationalCategories,
  role: state.auth.user.role,
  roles: state.auth.roles,
  error: state.error,
  success: state.success,
});
export default connect(mapStateToProps, {
  fetchEducationalCategories,
  deleteEducationalCategory,
  deleteEducationalCategories,
  clearErrors,
  clearSuccess,
})(EducationalCategories);
